// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";
import * as Curry from "melange.js/curry.jsx";

function mergeIntoMap(original, items, getKey) {
  const changedItems = items.filter(function (item) {
    const originalItem = original.get(Curry._1(getKey, item));
    if (originalItem !== undefined) {
      return !ReactRouter.deepEqual(item, originalItem);
    } else {
      return true;
    }
  });
  if (changedItems.length === 0) {
    return original;
  }
  const init = new Map(Array.from(original.entries()));
  return changedItems.reduce((function (map, newItem) {
    return map.set(Curry._1(getKey, newItem), newItem);
  }), init);
}

export {
  mergeIntoMap,
}
/* @tanstack/react-router Not a pure module */
